import { MAX_TEXT_LENGTH_MICROSOFT as MAX_TEXT_LENGTH } from '@d-id/tts';
import { IVoice, Providers } from '@d-id/types';

const characterLimitations: Record<Providers, number> = {
    [Providers.Amazon]: MAX_TEXT_LENGTH,
    [Providers.Microsoft]: MAX_TEXT_LENGTH,
    [Providers.AzureOpenAi]: MAX_TEXT_LENGTH,
    [Providers.Afflorithmics]: MAX_TEXT_LENGTH,
    [Providers.Elevenlabs]: MAX_TEXT_LENGTH,
    [Providers.Google]: MAX_TEXT_LENGTH,
};

export const validateTtsText = (ttsText: string, ttsSelectedVoice: IVoice | null) => {
    const maxLength = characterLimitations[ttsSelectedVoice?.provider || Providers.Microsoft];

    return {
        maxLength,
        textTooLong: ttsText.length > maxLength,
    };
};
